// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2bYljz3tBoWnTweOf6AmaH","MainColumn":"hW2u8PkR3OG5mW98iedu0","SideColumn":"_2I86sotrT7jX5aVeBTrWm5","StackOnMobile":"_3Gkv8OcIDYjTmbmKZ0y7IE","container-fluid":"_1uCRrvcWk-N5oeXOIJy9Lm"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/MobileRegistryUpload/styles.module.css
// module id = 638
// module chunks = 0